import { app } from "@/modules/app";
import { useStackRouteComponent } from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
  {
    parent: "public",
    path: "/pwa-install",
    component: useStackRouteComponent(
        () => import("@/pages/pwa/install.dialog.vue")
    ),
    meta: {
      title: "Установить приложение",
    },
  },
  {
    parent: "public",
    path: "/pwa-install-instructions",
    component: useStackRouteComponent(
        () => import("@/pages/pwa/install-instructions.dialog.vue")
    ),
    meta: {
      title: "Инструкции по установке",
    },
  },
]);
